import React, { useEffect, useState } from "react";
import SwitchButton from "../switch-button";
import FileUpload from "../file-upload";
import BulkUploadHistory from "./bulk-upload-history";
import BulkUploadFileDetails from "./bulk-upload-file-details";


const AddBulkUpload = () => {


    const [selected, setSelected] = useState("Upload");
    const [toggleDetails, setToggleDetails] = useState(false);
    const [selectedBulkUpload,setSelectedBulkUpload] = useState(null);

    const BulkFileDetails = (data) => {
        setToggleDetails(true)
        setSelectedBulkUpload(data)
    };  

    useEffect(()=>{
        if(selected == "Upload"){
            setToggleDetails(false);
        }
    },[selected]);


    return (
        <>

            <div className="flex justify-between items-start">
                <div className="flex-1 w-full">
                    <SwitchButton setSelected={setSelected} selected={selected} />
                    {selected === "Upload" ? <FileUpload /> : <BulkUploadHistory  toggleDetails={toggleDetails} BulkFileDetails={BulkFileDetails} />}
                </div>

                <div className={`add-bulk-upload transition-all block sticky h-full border-l ml-6 border-[#C8D6E6] bg-[#F5F5F5] top-[75px]`} >
                    {toggleDetails && (<>
                        <BulkUploadFileDetails selectedBulkUpload={selectedBulkUpload} toggleDetails={toggleDetails} setToggleDetails={setToggleDetails} />
                    </>)}
                </div>
            </div>
        </>
    );
};

export default AddBulkUpload;





